import React, { useState } from 'react';
import { Box, Typography, IconButton, Autocomplete, TextField } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import { db, auth } from '../../firebase'; // Ensure this path is correct
import { doc, setDoc } from 'firebase/firestore';
import axios from 'axios'; // Make sure axios is imported

const styleOptions = [
  { label: '3D Model', id: '3D_Model' },
  { label: 'Analog', id: 'Analog' },
  { label: 'Anime', id: 'Anime' },
  { label: 'Comic Book', id: 'Comic_Book' },
  { label: 'Cyberpunk', id: 'Cyberpunk' },
  { label: 'Digital Art', id: 'Digital_Art' },
  { label: 'Fantasy Art', id: 'Fantasy_Art' },
  { label: 'Line Art', id: 'Line_Art' },
  { label: 'Origami', id: 'Origami' },
  { label: 'Synthwave', id: 'Synthwave' },
  { label: 'Photorealistic', id: 'Photorealistic' },
  { label: 'Pixel Art', id: 'Pixel_Art' },
  // You can add more style options here as needed
];

function BrandDataInput(props) {
  const [productType, setProductType] = useState('');
  const [styleTypes, setStyleTypes] = useState([]);
  const [themeType, setThemeType] = useState('');
  const [colorChoice, setColorChoice] = useState('');
  // Inside your component definition
  const [loading, setLoading] = useState(false);
  const [setDesigns] = useState([]);
  // eslint-disable-next-line
  const [error, setError] = useState(null);
  const [randomGifUrl, setRandomGifUrl] = useState('');



  // Fetch Designs Function
  const fetchDesigns = async (uid) => {
    setLoading(true);
    try {
      const response = await axios.post(process.env.REACT_APP_GENERATE_RECOMMENDATIONS_API, { uid });
      if (response.data && response.data.recommendations) {
        setDesigns(response.data.recommendations);
      } else {
        setDesigns([]); // Ensure designs is always an array
      }
      setError(null);
    } catch (error) {
      console.error('Error fetching design recommendations:', error);
      setError(error);
    } finally {
      setLoading(false);
    }
  };
  
  
  
  const saveBrandDataToFirestore = async () => {
    if (!auth.currentUser) {
      console.error('No authenticated user found');
      return;
    }
  
    setLoading(true); // Start loading state
    const uid = auth.currentUser.uid;
    const brandRef = doc(db, 'users', uid);
  
    try {
      await setDoc(brandRef, {
        brandData: {
          productType,
          styleTypes: styleTypes.map(style => style.label),
          themeType,
          colorChoice,
        }
      }, { merge: true });
  
      console.log('Brand data saved successfully');
      await fetchDesigns(uid); // After saving, fetch designs
      props.onNext(); // Proceed to the next step
    } catch (error) {
      console.error('Error in processing', error);
    } finally {
      setLoading(false); // End loading state
    }
  };

  
  if (loading) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', width: '100%', position: 'fixed', top: 0, left: 0 }}>
        <img src={'/logo.png'} alt="Generating recommendations..." className="dancingImage" />
        <Typography variant="h6" sx={{ mt: 2, fontWeight: 'bold' }}>
            Generating recommendations...
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh',
        width: '100%',
        margin: 'auto',
        marginTop: '50px',
      }}
    >
        <IconButton
            aria-label="back"
            onClick={props.onPrevious}
            sx={{
            position: 'absolute',
            top: 50,
            left: 50,
            backgroundColor: 'transparent',
            color: '#ff4c15ff',
            '&:hover': {
                backgroundColor: 'rgba(255, 76, 31, 0.04)',
            },
            }}
        >
            <ArrowBackIosRoundedIcon />
        </IconButton>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: '10px',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
            padding: '50px',
            width: '50%',
            marginBottom: '50px',
          }}
        >
          <Typography variant="h5" sx={{ width: '100%', textAlign: 'left', marginBottom: '30px', fontWeight: 'bold' }}>
            Tell us about your brand...
          </Typography>

          {/* Product Type Section */}
          <Typography variant="h6" sx={{ width: '100%', textAlign: 'left', marginBottom: '10px', fontWeight: 'bold' }}>
            What <span style={{ color: '#ff4c15ff' }}>products</span> do you want to sell?
          </Typography>
          <Autocomplete
            value={productType}
            onChange={(event, newValue) => {
              setProductType(newValue);
            }}
            options={['T-Shirts']} // This should be replaced or expanded with your actual product options
            renderInput={(params) => <TextField {...params} />}
            sx={{
              width: '100%',
              marginBottom: '20px',
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#F5F5F5',
                '& fieldset': {
                  borderColor: 'transparent',
                },
                '&:hover fieldset': {
                  borderColor: 'transparent',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'transparent',
                },
              },
            }}
          />

          {/* Style Types Section */}
          <Typography variant="h6" sx={{ width: '100%', textAlign: 'left', marginBottom: '10px', fontWeight: 'bold' }}>
            What <span style={{ color: '#ff4c15ff' }}>styles</span> should your designs have?
          </Typography>
          <Autocomplete
            multiple
            value={styleTypes}
            onChange={(event, newValue) => {
              setStyleTypes(newValue);
            }}
            options={styleOptions}
            getOptionLabel={(option) => option.label}
            renderInput={(params) => <TextField {...params} />}
            sx={{
              width: '100%',
              marginBottom: '20px',
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#F5F5F5',
                '& fieldset': {
                  borderColor: 'transparent',
                },
                '&:hover fieldset': {
                  borderColor: 'transparent',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'transparent',
                },
              },
            }}
          />

          {/* Theme Type Section */}
          <Typography variant="h6" sx={{ width: '100%', textAlign: 'left', marginBottom: '10px', fontWeight: 'bold' }}>
            What <span style={{ color: '#ff4c15ff' }}>themes</span> do you envision?
          </Typography>
          <TextField
            value={themeType}
            onChange={(e) => setThemeType(e.target.value)}
            placeholder='e.g., Cars, Christmas, Animals, Robots, Cowboys...'
            fullWidth
            sx={{
              width: '100%',
              marginBottom: '20px',
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#F5F5F5',
                '& fieldset': {
                  borderColor: 'transparent',
                },
                '&:hover fieldset': {
                  borderColor: 'transparent',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'transparent',
                },
              },
            }}
          />

          {/* Color Choice Section */}
          <Typography variant="h6" sx={{ width: '100%', textAlign: 'left', marginBottom: '10px', fontWeight: 'bold' }}>
            Preferred <span style={{ color: '#ff4c15ff' }}>colors</span> for your designs?
          </Typography>
          <TextField
            value={colorChoice}
            onChange={(e) => setColorChoice(e.target.value)}
            placeholder="e.g., Red, Blue, Black, White"
            fullWidth
            sx={{
              width: '100%',
              marginBottom: '20px',
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#F5F5F5',
                '& fieldset': {
                  borderColor: 'transparent',
                },
                '&:hover fieldset': {
                  borderColor: 'transparent',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'transparent',
                },
              },
            }}
          />

          {/* Navigation Button */}
          <Box sx={{ display: 'flex', justifyContent: 'right', width: '100%', marginTop:'20px' }}>
            <IconButton
              aria-label="next"
              onClick={saveBrandDataToFirestore} // Modified to call saveBrandDataToFirestore function
              sx={{
                  width: '50px',
                  height:'50px',
                  backgroundColor: '#ff4c15ff',
                color: '#FFFFFF',
                '&:hover': {
                  backgroundColor: '#e2400f',
                },
                borderRadius: '10px',
              }}
            >
              <ArrowForwardIosIcon />
            </IconButton>
          </Box>
        </Box>
    </Box>
  );
}

export default BrandDataInput;
